import { render, staticRenderFns } from "./DoubleBounce.vue?vue&type=template&id=85a934c4&scoped=true"
import script from "./DoubleBounce.vue?vue&type=script&lang=js"
export * from "./DoubleBounce.vue?vue&type=script&lang=js"
import style0 from "./DoubleBounce.vue?vue&type=style&index=0&id=85a934c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a934c4",
  null
  
)

export default component.exports